export const BORDER_COLOR = 'rgba(0, 0, 0, 0.12)';
export const TEXT_COLOUR = 'rgba(0, 0, 0, 0.87)';
export const HOVER_BACKGROUND = 'rgba(0, 0, 0, 0.04)';
export const ICON_COLOR = 'rgba(0, 0, 0, 0.60)';
export const DEFAULT_FONT_SIZE = '1rem';
export const BOLD_FONT_WEIGHT = '700';
export const REGULAR_FONT_WEIGHT = '400';
export const MEDIUM_FONT_WEIGHT = '500';
export const INPUT_BACKGROUND = '#f5f5f5';